import { render, staticRenderFns } from "./chatMessages.vue?vue&type=template&id=207542ef&scoped=true"
import script from "./chatMessages.vue?vue&type=script&lang=js"
export * from "./chatMessages.vue?vue&type=script&lang=js"
import style0 from "./chatMessages.vue?vue&type=style&index=0&id=207542ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207542ef",
  null
  
)

export default component.exports